import React, { useState } from 'react'
import './header.css'
import Mobile from './Mobile/index'
import Web from './Web/index'

function Header() {
    const [isOpen,setisopen]=useState(false)
    const handleLogoClick = () => {
        window.scrollTo(0, 0);
      };
      window.onscroll = function () {
        setisopen(false);
      };
    return (
        <div className='header'>
           <div onClick={handleLogoClick} className='logo'>Romit Choudhary</div>
           <div className='menu'>
             <div className='web-menu'><Web /></div>
             <div className="mobile-menu">
                 <div onClick={() =>setisopen(!isOpen)}>
                 <i class="fi-rr-apps menu-icon"></i>
                 </div>
                 {isOpen&&<Mobile isOpen={(isOpen)} setisopen={(setisopen)} />}
             </div>
           </div>
        </div>
    )
}

export default Header
